import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import {push} from 'react-router-redux';
import queryString from 'query-string';

import {request} from '../../containers/actions';
import {imageUrl} from '../../utilities/requests';
import {refresh as paginatorRefresh, removeItem, clearSelection} from '../../paginator/actions';
import PaginatedContainer from '../../paginator/paginated_container';


export default class ExaminationCatalogues extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: false,
        actions: [],
        buttonActions: [],
    }

    listFields = [
        {field: 'id', label: window.gettext('ID')},
        {field: 'title', label: window.gettext('Title')},
        {
            field: item => <img src={imageUrl(item.cover_photo, {
                height: 40,
                type: 'contain',
            })}/>,
            label: window.gettext('Cover Photo'),
        },
    ]

    sorts = [

        // {name: 'id', label: window.gettext('ID'), reversed: true},
        // {name: 'title', label: window.gettext('title')},
        // {name: 'grade', label: window.gettext('Grade')},
    ]

    buttonActionsSelector = createSelector(
        [
            () => this.props.buttonActions,
            () => this.props.readonly,
        ],
        () => this.props.readonly
            ? this.props.buttonActions
            : _.concat(this.props.buttonActions, [
                {
                    label: window.gettext('New Catalogue'),
                    action: () => this.context.store.dispatch(push(
                        this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        ) + 'add/',
                    )),
                },
            ]),
    )

    componentDidUpdate(prevProps) {
        if (prevProps.params.id && !this.props.params.id) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
    }

    render() {
        return <PaginatedContainer
            store={this.props.store.get('paginator')}
            resource='examination-catalogue'
            title={window.gettext('Examination Catalogues')}
            listFields={this.listFields}
            selectable
            sorts={this.sorts}
            pageSize={this.props.pageSize}
            active={this.props.params.id}
            buttonActions={this.buttonActionsSelector(this.props.store)}
        />;
    }
}
